import React, { useEffect, useState } from 'react';
import {
    TextField,
    Button,
    Typography,
    Box,
    Container,
    Grid,
    Paper,
    Stack,
    Link,
} from '@mui/material';
import { Grid2 } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, styled } from '@mui/material/styles';

import logo  from '../assets/images/booking.png'
import screen1 from '../assets/images/screen_1.jpg'
import screen2 from '../assets/images/screen_2.jpg'
import screen3 from '../assets/images/screen_3.jpg'
import screen4 from '../assets/images/screen_4.jpg'

import {
    GooglePlayButton,
    AppGalleryButton,
    AppStoreButton,
    ButtonsContainer,
} from "react-mobile-app-button";
import { useBookContext } from "../contexts/bookContext";
import axios from "axios";

const Home = () => {
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();
    const [init, setInit] = useState(true);
    const params = useParams(); 
    const [searchParams, setSearchParams] = useSearchParams();
    const paramUserEmail = searchParams.get('userEmail') || undefined;
    const paramUserPw = searchParams.get('userPw') || undefined;
    const queryList = [...searchParams];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const APKUrl = "https://play.google.com/store/apps/details?id=com.weplystudio.booking";
    const IOSUrl = "https://apps.apple.com/us/app/부킹히어로-회원용/id6749930486";



    useEffect(() => {
        actions.extendTime(userData);
        if (paramUserEmail && paramUserPw) {
//            login();
        }

    }, [init]);



    const login = async () => {

        try {

            const reqData = {};
            reqData.userEmail = paramUserEmail;
            reqData.userPW = paramUserPw;


            let response = await axios.post("/api/booking/CheckUser", reqData);
            //            console.log("login result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                let userInfo = response.data.result;
                var newData = {}
                newData.userEmail = userInfo.userEmail;
                newData.userPhone = userInfo.userPhone;
                newData.userName = userInfo.userName;
                newData.chargeMoney = userInfo.chargeMoney;
                newData.chargeCount = userInfo.chargeCount;
                newData.bonusCount = userInfo.bonusCount;
                newData.unlimitUser = userInfo.unlimitUser;

                updateUserInfo(newData);
                //("home save new userdata")
                //                checkLogin();


            }
        } catch (err) {
            console.error(err);
        }

    }



    return (
        <Container maxWidth="md" sx={{ mt: 5, mb: 10 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Box sx={{
                    display: 'flex',
                    //                justifyContent: 'center', // Centers content horizontally
                    //                minHeight: '100vh',      // Example: ensures the Box takes full viewport height
                    // Add other styling as needed
                    marginTop: 3

                }}>
                    <Stack direction="row" spacing={2}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box sx={{ boxShadow: 2, borderRadius: 2, }}>
                            <img src={logo} width={64} height={64} />
                        </Box>
                        <Typography variant="h4" gutterBottom style={{ marginTop: 10 }}>{"부킹히어로"}</Typography>
                    </Stack>
                </Box>

                <Box sx={{ marginTop: 5 }}>
                    <Typography
                        sx={{ color: 'text.secondary', mb: { xs: 1, sm: 1 } }}
                    >
                        부킹히어로를 통한 부킹예약은 전용 어플을 통해서 이루어 집니다. 아래 링크를 통해 해당 폰기종에 맞는 어플을 설치하시거나
                        플레이스토어 혹은 앱스토어에서 부킹히어로를 검색하시고 해당 어플을 설치해 주세요
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', }}
                    >
                        어플을 설치하시고 회원가입한 이메일과 패스워드로 로그인 하시면 됩니다
                    </Typography>

                </Box>

                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 1, sm: 2, md: 4 }}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 5
                    }}
                >
                    <GooglePlayButton
                        url={APKUrl}
                        theme={"dark"}
                    />

                    <AppStoreButton
                        url={IOSUrl}
                        theme={"dark"}
                    />
                </Stack>

                <Typography
                    component="h2"
                    variant="h6"
                    gutterBottom
                    sx={{ mt: 5, color: 'text.primary' }}
                >
                    사용안내
                </Typography>
                <Box sx={{ marginTop: 1 }}>
                    <Typography
                        sx={{ color: 'text.primary', }}
                    >
                        1. 예치금을 충전하면 어플에 코스선택이라는 탭이 나타납니다
                    </Typography>
                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        2. 코스선택에서 주로 사용하시는 골프코스를 입력하시고 승인을 기다립니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 승인은 보통 24시간이내에 이루어집니다
                    </Typography>



                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        3. 승인이 완료되면 [부킹신청]에서 티업 날짜를 선택하고 [부킹 세부 설정]을 입력하시면됩니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 예약시 부킹가능 횟수와 충전금이 차감됩니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 작업후 부킹실패시 충전금과 부킹가능 횟수는 복원됩니다
                    </Typography>

                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        4. 부킹시도 후 결과를 메세지로 보내드리며 [부킹내역]에서도 확인가능합니다
                    </Typography>
                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        5. 부킹시 인증번호가 필요한 골프장의 경우 인증번호를 입력하라는 메세지가 날아갑니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 받으신 인증번호를 [인증번호] 탭에서 입력하세요
                    </Typography>
                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        6. 그외 궁금하신 사항은 [내정보] - [문의사항]을 이용하시거나 아래 링크로 들어오시면 됩니다  
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        <Link x={{ ml: { xs: 1, sm: 1 }, }} href="https://booking.imweply.com" target="_blank" rel="noopener noreferrer">
                            - https://booking.imweply.com
                        </Link> 
                    </Typography>

                </Box>                

                <Typography
                    component="h2"
                    variant="h6"
                    gutterBottom
                    sx={{ mt: 5, color: 'text.primary' }}
                >
                    장점
                </Typography>
                <Box sx={{ marginTop: 2 }}>
                    <Typography
                        sx={{ color: 'text.primary',  }}
                    >
                        1. 골프장 별로 프로그램을 개별 구매할 필요가 없습니다.
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 },   }}
                    >
                        - 부킹히어로 하나만으로도 여러 골프장의 부킹을 이용할 수 있습니다
                    </Typography>

                </Box>

                <Box sx={{ marginTop: 1 }}>
                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        2. 사용 및 관리가 용이합니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 어플로 예약등록만 하면되며 프로그램을 계속 켜둘필요가 없습니다
                    </Typography>

                </Box>

                <Box sx={{ marginTop: 1 }}>
                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        3. 비용이 저렴합니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 부킹 성공여부 관련없이 구매해야하는 프로그램들과 달리 성공시에만 비용이 차감됩니다
                    </Typography>

                </Box>
                <Box sx={{ marginTop: 1 }}>
                    <Typography
                        sx={{ marginTop: 1, color: 'text.primary', }}
                    >
                        4. 다양한 골프장 지원
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 부킹가능한 골프장은 꾸준히 업데이트 됩니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 신규 요청하는 골프장이 있을시 비용없이 우선적으로 추가 됩니다
                    </Typography>
                    <Typography
                        sx={{ color: 'text.secondary', ml: { xs: 1, sm: 1 }, }}
                    >
                        - 신규 요청시 개발기간은 2~3일 정도 소요됩니다
                    </Typography>

                </Box>
                


            </Paper>
            

        </Container>

    )
}
export default Home;